import React from "react";
import { makeStyles } from "@material-ui/core";
import { object, string } from "yup";

export const useStyleFormAssignRoom = makeStyles(theme => ({
    border: {
        border: "1px solid rgba(0, 0, 0, 0.23)",
    },
    select: {
        "& .MuiOutlinedInput-inputMarginDense": {
            paddingTop: 13,
            paddingBottom: 13,
        },
    },
    input: {
        "& .MuiOutlinedInput-inputMarginDense": {
            paddingTop: 13,
            paddingBottom: 13,
        },
        "& .MuiInputLabel-formControl": {
            top: 3,
            color: "#dfdfdf !important",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderWidth: "1px !important",
        },
    },
}));

// start material table options
export const initialBuildingTableOptions = {
    pageSize: 20,
    pageSizeOptions: [5, 10, 20, 50],
    actionsColumnIndex: -1,
    emptyRowsWhenPaging: false,
    headerStyle: {
        fontSize: 15,
    },
    debounceInterval: 500,
    // have not affect table
    totalData: 0,
    order: "",
    direction: "",
};

export const initialFloorTableOptions = {
    pageSize: 20,
    pageSizeOptions: [5, 10, 20, 50],
    actionsColumnIndex: -1,
    emptyRowsWhenPaging: false,
    headerStyle: {
        fontSize: 15,
    },
    debounceInterval: 500,
    // have not affect table
    totalData: 0,
    order: "",
    direction: "",
};

export const initialRoomTableOptions = {
    pageSize: 20,
    pageSizeOptions: [5, 10, 20, 50],
    actionsColumnIndex: -1,
    emptyRowsWhenPaging: false,
    headerStyle: {
        fontSize: 15,
    },
    debounceInterval: 500,
    // have not affect table
    totalData: 0,
    order: "",
    direction: "",
};

// end material table options

// start material table columns
export const buildingTableColumns = [
    {
        field: "name",
        title: "Building",
    },
];

export const floorTableColumns = [
    {
        field: "Building.name",
        title: "Building",
        render: row => <div>{row?.buildingName}</div>,
    },
    {
        field: "name",
        title: "Floor",
    },
    {
        field: "locationCode",
        title: "Location Code",
    },
    {
        field: "locationName",
        title: "Location Name",
    },
    {
        title: "Rights",
        field: "rights",
        render: row => {
            if (row?.rights === "0") {
                return "สิทธิประกันสังคม";
            } else if (row?.rights === "1") {
                return "สิทธิทั่วไป";
            } else {
                return null;
            }
        },
    },
];

export const roomTableRoom = [
    {
        field: "Floor.Building.name",
        title: "Building",
        render: row => <div>{row?.Floor?.Building?.name}</div>,
    },
    {
        field: "Floor.name",
        title: "Floor",
        render: row => (
            <div>
                {row?.Floor?.name} / {row?.Floor?.locationName}
            </div>
        ),
    },
    {
        field: "name",
        title: "Room",
        render: row => (
            <div>
                {row?.name} / {row?.nameEn}
            </div>
        ),
    },
];

export const roomTableColumns = [
    {
        field: "Floor.Building.name",
        title: "Building",
        render: row => <div>{row?.Floor?.Building?.name}</div>,
    },
    {
        field: "Floor.name",
        title: "Floor",
        render: row => (
            <div>
                {row?.Floor?.name} / {row?.Floor?.locationName}
            </div>
        ),
    },
    {
        field: "name",
        title: "Room",
        render: row => (
            <div>
                {row?.name} / {row?.nameEn}
            </div> 
        )
    },
    {
        field: "doctor",
        title: "Doctor",
        render: row =>
            row.RoomDoctors.map((item, idx) => {
                return (
                    <div key={idx}>
                        {item?.Doctor?.Doctorname} (
                        {item?.moment === "0"
                            ? "เช้า"
                            : item?.moment === "1"
                            ? "บ่าย"
                            : item?.moment === "2"
                            ? "ค่ำ"
                            : ""}{" "}
                        - {JSON.parse(item?.dayRoom).join(", ")})
                    </div>
                );
            }),
    },
];
// end material table columns

// start formik initial values
export const initialBuildingValues = {
    buildingName: "",
};

export const initialFloorValues = {
    permission_floor: "",
    buildingId: "",
    floorName: "",
    locationCode: "",
    locationName: "",
};

export const initialRoomValues = {
    buildingId: "",
    floorId: "",
    status: "",
    roomName: "",
    roomNameEnglish: "",
};
// end formik initial values

// start formik schema
export const buildingSchema = object({
    buildingName: string().required("Required."),
});

export const floorSchema = object({
    permission_floor: string().required("Required."),
    buildingId: string().required("Required."),
    floorName: string().required("Required."),
    locationCode: string().required("Required."),
    locationName: string().required("Required."),
});

export const roomSchema = object({
    buildingId: string().required("Required."),
    floorId: string().required("Required."),
    roomName: string().required("Required."),
    roomNameEnglish: string().required("Required."),
    status: string().required("Required."),
});
// end formik schema
